import React, {useCallback, useMemo, useState} from "react";
import "./index.scss";
import {ModalPortal} from "features/components/modal";
import {Icon} from "features/components/icon";
import Title from "features/components/title";
import {__} from "services/i18n";
import Text from "features/components/text";
import PasswordTextField from "features/components/password-text-field";
import Button from "features/components/button";
import {connect} from "react-redux";
import {PasswordValidator} from "services/utils/validations";
import {changePasswordSetShow, changePasswordStart} from "features/modals/change-password/reducer";
import {changePasswordErrorSelector, changePasswordLoadingSelector} from "features/modals/change-password/selectors";

/* istanbul ignore next */
const mapStateToProps = state => ({
    error: changePasswordErrorSelector(state),
    loading: changePasswordLoadingSelector(state)
});
/* istanbul ignore next */
const mapDispatchToProps = {
    changePasswordStart,
    changePasswordSetShow
};

export const ChangePasswordModal = (props) => {
    const {loading, error, changePasswordStart, changePasswordSetShow} = props;

    const [oldPassword, setOldPassword] = useState("");
    const [password, setPassword] = useState("");
    const [confirm, setConfirm] = useState("");

    const validatePassword = useCallback((val) => {
        return PasswordValidator(val) ? null : __("validator.invalid-password");
    }, []);

    const checkPassword = useCallback(() => {
        return password === confirm ? null : __("validator.password-no-match");
    }, [password, confirm]);

    const buttonEnabled = useMemo(() => {
        return PasswordValidator(password) && PasswordValidator(oldPassword) && (password === confirm);
    }, [password, confirm, oldPassword]);

    const doSave = useCallback(() => {
        changePasswordStart({password, old_password: oldPassword});
    }, [changePasswordStart, password, oldPassword]);

    const doCancel = useCallback(() => {
        changePasswordSetShow(false)
    }, [changePasswordSetShow]);

    return <ModalPortal size={"small"} className={"change-password-modal"}>
        <Icon>key</Icon>
        <Title size={24} align={"center"}>{__("change-password.title")}</Title>
        <div className="field-box">
            <PasswordTextField
                value={oldPassword}
                onChange={setOldPassword}
                placeholder={__("text-fields.old-password.placeholder")}
                hint={__("text-fields.old-password.hint")}
                validationFunc={validatePassword}
            />
            <PasswordTextField
                value={password}
                onChange={setPassword}
                placeholder={__("text-fields.password.placeholder")}
                hint={__("text-fields.password.hint")}
                validationFunc={validatePassword}
            />
            <PasswordTextField
                value={confirm}
                onChange={setConfirm}
                placeholder={__("text-fields.confirm-password.placeholder")}
                hint={__("text-fields.confirm-password.hint")}
                validationFunc={(val) => {
                    return validatePassword(val) || checkPassword()
                }}
            />
        </div>
        {error.inError && <Text size={16} align={"center"} color={"danger"}>{__(error.error)}</Text>}
        <Button title={__("buttons.confirm-new-password")} disabled={!buttonEnabled} onClick={doSave} status={loading ? "loading" : null} icon={"thumbs-up"} />
        <Button title={__("buttons.cancel")} onClick={doCancel} type={"outlined"} size={"small"} />
    </ModalPortal>
}
export default connect(mapStateToProps, mapDispatchToProps)(ChangePasswordModal);